<template>
  <v-dialog
    v-model="alwaysOpen"
    :fullscreen="isMobile"
    width="80%"
    max-width="512px"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card class="form-dialog form-dialog--new-user">
      <v-icon
        class="form-dialog__button form-dialog__button--close"
        @click="close"
      >
        mdi-close
      </v-icon>

      <h1 class="form-dialog__title">Add ANPR connection</h1>
      <span class="form-dialog__subtitle">
            Select an integration to allow automatic payments at this locations.
      </span>
      <v-form class="mt-8">
        <v-row dense>
          <v-col cols="12" style="height: 34px">
            <v-select
            class="form-font pkmn-input"
            background-color="#F6F6F6"              
            v-model="selectedANPR"
            :items="anprList"
            item-value="id"
            item-text="name"
            label="ANPR system"
            clearable
            solo
            flat
            dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" style="height: 28px"></v-col> 
        </v-row>
        <v-row dense>
          <v-col cols="12" style="height: 34px">
            <v-text-field
                solo
                flat
                dense
                background-color="#F6F6F6"
                label="Integration code"
                v-model="integratorLocationCode"
                class="pkmn-input"
                :rules="[rules.required]"
              >
              </v-text-field>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" style="height: 28px"></v-col>
      </v-row>
      <v-row dense>
          <v-col cols="12" style="height: 34px">
            <v-select
            class="form-font pkmn-input"
            background-color="#F6F6F6"              
            v-model="startParkingFeature"
            :items="startParkingOption"
            item-value="id"
            item-text="displayName"
            label="Start parking"
            solo
            flat
            dense
            multiple
            :rules="[rules.arrayRequired]"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" style="height: 28px"></v-col> 
        </v-row>
        <v-row dense>
          <v-col cols="12" style="height: 34px">
            <v-select
            class="form-font pkmn-input"
            background-color="#F6F6F6"              
            v-model="stopParkingFeature"
            :items="stopParkingOption"
            item-value="id"
            item-text="displayName"
            label="Stop parking"
            solo
            flat
            dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" style="height: 28px"></v-col> 
        </v-row>
        <v-row class="form-dialog__button-wrap">
        <v-col cols="6">
          <v-btn class="pkmn-button" outlined color="primary" @click="close">
            Cancel
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            class="pkmn-button pkmn-button--confirm pkmn-button--has-border"
            color="primary"
            @click="add"
            :disabled="selectedANPR === null || integratorLocationCode === null || integratorLocationCode === '' || startParkingFeature.length === 0" 
          >
            Add
          </v-btn>
        </v-col>
      </v-row>
      </v-form>

    </v-card>
  </v-dialog>
</template>

<script>
import dropdownNarrow from '@/assets/dropdown_arrow.svg'
import rules from '@/helpers/validation'

export default {
  name: 'FormAddANPR',
  props: {
    anprList: {
      type: Array,
      default: () => []
    },
    startParkingOption: {
      type: Array,
      default: () => []
    },
    stopParkingOption: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      alwaysOpen: true,
      selectedANPR: null,
      dropdownNarrow,
      integratorLocationCode: null,
      productFeaturesIds: [],
      rules: {
        ...rules
      },
      startParkingFeature: [],
      stopParkingFeature: null
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    add() {
      if (this.startParkingFeature.length !== 0) {
        this.productFeaturesIds = [...this.startParkingFeature]
      }
      if (this.stopParkingFeature !== null) {
        this.productFeaturesIds.push(this.stopParkingFeature)
      }
      const record = {
            integrator_id: this.selectedANPR,
            integrator_location_code: this.integratorLocationCode,
            product_features_ids: this.productFeaturesIds
      }
      this.$emit('add', record)
    }
  },
  mounted() {
    this.startParkingFeature = [this.startParkingOption[0].id]
    this.stopParkingFeature = this.stopParkingOption[0].id
  }
}
</script>
<style lang="scss">
@import '@/style/common';

.v-text-field__details {
  padding: 0px !important;
}

.col:has(.v-input--is-focused) {
  .text-input-label {
    color: $color-brand;
  }
}

.warden-picker {
  padding: 24px
}
.form-dialog--new-user .v-input--is-focused .v-input__slot {
  border: 1px solid $color-brand !important;
}

.form-dialog--new-user .v-input.error--text .v-input__slot {
  border: 1px solid $color-danger !important;
}

.my-text-field ::v-deep .v-text-field__details .v-messages {
  display: flex;
  justify-content: flex-end;
}
</style>
